<template>

    <div class="interior-view" id="documentsSets">
        <section v-if="invitations.length" class="invitations">
            <div>
                <h3>Invitations</h3>
                <div v-for="invitation in invitations" class="row">
                    <div class="col-sm-8 text-left invitation-title">{{invitation.documentSet.fullName}}</div>
                    <div class="col-sm-4 text-right">
                        <button class="btn btn-primary" @click="handleInvitation(invitation, 'accepted')">Accept</button>
                        <button class="btn" @click="handleInvitation(invitation, 'declined')">Decline</button>
                    </div>
                </div>
            </div>
        </section>
        <section v-if="documentSetsExist" class="document-sets clearfix">
            <div v-if="store.data.documentSets.ownedSets.length">
                <h3>My Documents</h3>
                <p v-for="set in store.data.documentSets.ownedSets">
                    <router-link :to="'/documents-view/owneddocumentsets/' + set.id" class="btn btn-wide btn-document-set">{{ set.name }}</router-link>
                </p>
            </div>
            <div v-if="store.data.documentSets.sharedSets.length">
                <h3>Documents Shared With Me</h3>
                <p v-for="set in store.data.documentSets.sharedSets">
                    <router-link :to="'/documents-view/shareddocumentsets/' + set.id" class="btn btn-wide btn-document-set">

                        <div v-for="owner in set.owners">{{owner.user.firstName}} {{owner.user.lastName}}</div>
                        <div class="set-title">{{ set.name }}</div>
                    </router-link>
                </p>
            </div>
        </section>
    </div>

</template>



<script>

    import DocumentSetsService from '@/services/document-sets.service'
    import UserInvitationsService from '@/services/user-invitations.service'
    import UserService from '@/services/user.service'
    import Q from 'q';
    import { Store } from '@/store.js'

    export default {

        name: 'documentSets',

        data() {
            return {
                store: Store,
                invitations: []
            }
        },

        computed: {
            documentSetsExist: function() {
                return Object.keys(this.store.data.documentSets).length>0
            },
        },

        created: function() {
            this.requestAll()
        },

        methods: {

            requestAll: function() {
                var promises = [this.requestDocumentSetsList(), this.requestInvitationsForUser()];
                return Q.all(promises)
                    .then(use.bind(this))
                    .then(redirectIfNeeded.bind(this))

                function use(result) {
                    this.store.data.documentSets = result[0]
                    this.invitations = result[1]
                    return result
                }

                function redirectIfNeeded(result) {
                    var combinedDocSets = this.store.data.documentSets.ownedSets.concat(this.store.data.documentSets.sharedSets);
                    if (combinedDocSets.length==1 && this.invitations.length==0) {
                        this.$router.push('/documents-view/'+combinedDocSets[0].setType+'/'+combinedDocSets[0].id)
                    }
                    return result
                }
            },

            requestDocumentSetsList: function() {
                return DocumentSetsService.getAll()
            },

            requestInvitationsForUser: function() {
                return UserInvitationsService.getInvitationsForUser()
            },

            handleInvitation: function(invitation, status) {
                UserInvitationsService.handleInvitation(invitation, status)
                    .then(this.requestAll)
            }
        }
    }

</script>



<style lang="scss" scoped>

    @import "../variables";

    .document-sets {

        h3 {
            font-size: 1.3em;
            margin-bottom: 0;
        }
    }

    a.btn-wide {
        display: block;
        padding: .5em;
        font-size: 1.2em;
        white-space: normal;
        background-color: #eee;
        border: 1px solid #ccc;

        &:hover {
            background-color: lighten($brand-blue, 10%);
            color: #fff;
        }

        @media screen and (min-width: $screen-sm-min) {
            font-size: 1.5em;
        }
    }

    .btn-wide {
        width: 100%;
        line-height: 1.2;
    }

    .set-title {
        font-size: 0.7em;
        margin-bottom: .2em;
    }

    .invitation-title {
        text-align: left;
    }

    .text-right {
        text-align: right;
    }

    .invitations .row {
        margin-bottom: 5px;
    }

</style>



// WEBPACK FOOTER //
// DocumentSets.vue?5c18f857